import { AccountTabItem, DocumentSlot, KycCaptureCopy, KycPhoto } from './types';

const faceSample = require('../../../assets/images/kyc_personal.png');
const idSample = require('../../../assets/images/kyc_id.png');

export const accountTabs: AccountTabItem[] = [
    { id: 'Personal', title: 'Personal information' },
    { id: 'WorkExperience', title: 'Work experience' },
    { id: 'Education', title: 'Education' },
    { id: 'Expertise', title: 'Expertise' },
    { id: 'Files', title: 'Uploaded files' },
    { id: 'Identify', title: 'Identifying' },
];

/** Stands in for a field the applicant has not filled in. */
export const EMPTY_VALUE = '----';

/** An applicant may list at most this many areas of expertise. */
export const MAX_EXPERTISE = 3;

/** Ids of skills the applicant typed themselves are negative, to keep them apart from the list. */
export const FIRST_CUSTOM_SKILL_ID = -1;

/** KYC states the identifying tab knows how to render. */
export const KYC_APPROVED = 'approved';
export const KYC_NOT_APPROVED = 'notApproved';

export const documentSlots: DocumentSlot[] = [
    { type: 'Resume', title: 'Resume', field: 'resumeFileKey', label: 'Resume' },
    { type: 'Portfolio', title: 'Portfolio', field: 'portfolioFileKey', label: 'Portfolio' },
    { type: 'Cover', title: 'Cover letter', field: 'coverLetterFileKey', label: 'cover letter' },
    { type: 'Certificate', title: 'Certificate', field: 'certificateFileKey', label: 'Certificate' },
];

export const DOCUMENT_FILE_TYPES = {
    'application/pdf': ['.pdf'],
    'application/doc': ['.doc', '.docx'],
};

export const DOCUMENT_UPLOAD_HINT = 'PDF, Doc or Docx , Maximum upload file size: 12MB';

export const PHOTO_FILE_TYPES = { 'image': ['.PNG', '.JPEG', '.JPG'] };

export const PHOTO_UPLOAD_HINT = 'PNG, JPEG or JPG , Maximum upload file size: 15MB';

export const UPLOAD_ERROR_MESSAGE = 'Somthing went wrong. Please try again';

export const VIDEO_CONSTRAINTS = {
    width: { ideal: 1280 },
    height: { ideal: 720 },
    facingMode: 'user',
};

export const kycCaptureCopy: Record<KycPhoto, KycCaptureCopy> = {
    Face: {
        sample: faceSample,
        imageAlt: 'Captured face',
        cameraTitle: 'Please position your face within the frame',
        uploadTitle: 'Please upload your face photo',
        cameraHint: ' Also you can upload the relevant documents',
        uploadHint: 'Also you can take a live photo of your face',
    },
    Id: {
        sample: idSample,
        imageAlt: 'Captured ID',
        cameraTitle: 'Please take a live photo of your ID or upload the relevant document',
        uploadTitle: 'Please upload your identity document',
        cameraHint: ' Also you can upload the relevant documents',
        uploadHint: 'Also you can take a live photo of your ID',
    },
};
